import React from 'react'
import {
    HomeHeroBg,
    Section1 as section1,
    Section2 as section2,
    Section3,
    Section4,
    banner
} from "../../assets"
import Section1 from './Section1'
import Services from "./Services"
import { Banner, Nav, Footer } from "../../components"

import { motion } from "framer-motion";

const data = [
    {
        bg: HomeHeroBg,
        img: section1,
        h3: 'Our Signature services',
        h1: 'NFT Games <br /> Development',
        p: `” With our signature NFT Gaming development services, 
        businesses can process large volumes of scalable tokens 
         as per the game or product requirement. ” `
    },
    {
        img: section2,
        // bg: Section2Bg,
        bgColor: "rgba(15, 15, 15, 0.94)",
        h2: `WELCOME TO RAPIDEV GAMES`,
        pSmall: `Rapidev Games is a well-recognized unity 3D game development company hosting experts competent to fulfill your unique requirements in an extraordinary manner. At Rapidev Games, we develop impressive games, interactive visualizations rich in AR and VR experiences and deliver you the best-in-class gaming applications. Our experts possess sound knowledge of unity game programming, which assures you to avail gaming solutions that have an edge over your competitors.`,
        srcset: ` https://rapidevgames.com/wp-content/uploads/2018/06/h2-img-3.png 613w, https://rapidevgames.com/wp-content/uploads/2018/06/h2-img-3-284x300.png 284w, https://rapidevgames.com/wp-content/uploads/2018/06/h2-img-3-600x634.png 600w`,
        sizes: `(max-width: 613px) 100vw, 613px`
    },
    {
        img: Section3,
        h2: `WE ARE SPECIALIZED <br/>IN NFT GAMES <br/>DEVELOPMENT`,
        pSmall: `With our signature NFT Gaming development services, businesses can process large volumes of scalable tokens as per the product requirement. At Rapidev Games, we understand that this shift in power to the gamer means game developers need to up their game. They need to design and mint (the process of creating new NFTs) quality items that people want to buy and use — and when the gamer chooses to trade that item, they will expect a seamless experience.`,

    },
    {
        img: Section4,
        h2: `WE MAKE DREAMS<br/>ICOME TO LIFE`,
        pSmall: `Rapidev Games provides quality deliverable to customer across the globe. Our pioneer team does critical analysis to convert your ideas into reality. Rapidev comprised of genius developers, designers, modelers, web designers and software engineers team that gives simple solutions for complex connections and works to meet client’s demands. We highly prioritize customer satisfaction by our services and assist them through each and every step of execution in the development process. Moreover, our team performs to achieve best and rapid results to create value for our clients on time. Your potential Our Passion, We make it happen.

`
    },
]
function About() {
    return (
        <motion.div
            className='homePage'
            transition={{ duration: 1.2 }}
            exit={{ filter: ' brightness(0) ', }}
        >
            <Nav k={'2'} bgBlackTransparent />
            <Banner img={banner} />
            <main>
                <Section1 data={data[1]} />
                <Services />
            </main>
            <Footer />
        </motion.div>
    )
}

export default About